import { useParams } from "react-router-dom";
import BlogPostPage from "@/pages/BlogPostPage";
import NotFoundPage from "@/pages/NotFoundPage";
import blogPosts from "@/data/blogPosts";

// Reserved/known top-level paths that should NEVER be treated as blog slugs.
// (App.js already has explicit routes for these, this is just a defensive guard
// if the user types a path that doesn't match any defined route.)
const RESERVED = new Set([
  "admin", "solutions", "products", "exchange", "blog", "why", "careers",
  "contact", "accessibility", "customer-portal", "events", "privacy-policy",
  "privacy", "terms-of-service", "terms", "openhouse", "aether", "academy",
  "case-studies", "integrations", "request-a-demo", "we-are-hiring", "advance",
  "sitemap.xml", "robots.txt",
]);

export default function CatchAllRoute() {
  const { slug } = useParams();
  if (!slug) return <NotFoundPage />;
  const cleaned = slug.toLowerCase().replace(/^\/+|\/+$/g, "");
  if (RESERVED.has(cleaned)) return <NotFoundPage />;
  const post = blogPosts.find((p) => p.slug === cleaned);
  if (post) return <BlogPostPage />;
  return <NotFoundPage />;
}
